import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Newspaper, Image as ImageIcon, CalendarDays, ArrowLeft } from 'lucide-react';
import { LT } from '../lib/appCatalogue';
import { useT } from '../contexts/LocaleProvider';

/* Shared header bar for the three "Newsletter management" admin pages
 * (newsletters / photos / events). Surfaces the hub navigation in one
 * spot so editors don't have to bounce back to /admin to switch tools.
 *
 * Drop in at the top of each admin page, replacing the old
 * "← Beheer" + "MANEVA · CMS" eyebrow combo. The current page is
 * highlighted via the route prefix. */
export default function NewsletterAdminNav() {
  const t = useT();
  const { pathname } = useLocation();
  const isPhotos = pathname.startsWith('/admin/newsletter-photos');
  const isEvents = pathname.startsWith('/admin/newsletter-events');
  const isNewsletters = !isPhotos && !isEvents && pathname.startsWith('/admin/newsletters');

  return (
    <div className="mb-5 flex items-center gap-3 flex-wrap">
      <Link to="/admin"
            className="inline-flex items-center gap-1.5 text-[12.5px]"
            style={{ color: LT.green50 }}>
        <ArrowLeft className="h-3.5 w-3.5" /> {t('newsletterAdmin.back')}
      </Link>
      <span className="text-[11px] uppercase tracking-[0.16em] font-medium pl-2"
            style={{ color: LT.green50 }}>
        {t('newsletterAdmin.hubLabel')}
      </span>
      <nav className="inline-flex items-center rounded-md overflow-hidden text-[12.5px] ml-auto"
           style={{ border: `1px solid ${LT.green30}` }}>
        <Tab to="/admin/newsletters" icon={Newspaper} active={isNewsletters}>
          {t('newsletterAdmin.tab.episodes')}
        </Tab>
        <Tab to="/admin/newsletter-photos" icon={ImageIcon} active={isPhotos} divider>
          {t('newsletterAdmin.tab.photos')}
        </Tab>
        <Tab to="/admin/newsletter-events" icon={CalendarDays} active={isEvents} divider>
          {t('newsletterAdmin.tab.events')}
        </Tab>
      </nav>
    </div>
  );
}

const Tab = ({ to, icon: Icon, active, divider, children }) => (
  <Link
    to={to}
    className={`inline-flex items-center gap-1.5 px-3 py-1.5 transition ${divider ? 'border-l' : ''}`}
    style={{
      background: active ? LT.greenDeep : 'transparent',
      color: active ? '#fefefe' : LT.greenDeep,
      borderColor: LT.green30,
      fontWeight: active ? 600 : 400,
    }}
  >
    <Icon className="h-3.5 w-3.5" />
    {children}
  </Link>
);
